// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__r70Mb","tab":"Tabs_tab__+mO4m","active":"Tabs_active__ebFur"};